<script setup lang="ts">
import type { CarouselProps } from '@/components/Carousel/Carousel.types';

const props = defineProps<CarouselProps>();

const CAROUSEL_TIMEOUT = 15000;

const showing = ref();
const timeout = ref();

watchEffect(() => {
  if (props.items.length) start();
});

onUnmounted(() => {
  clearTimeout(timeout.value);
});

const start = () => {
  clearTimeout(timeout.value);

  const firstItemId = props.items[0].id;
  showing.value = firstItemId;

  /* timeout.value = setInterval(() => {
      const showingIndex = props.items.findIndex(
        (item) => item.id === showing.value,
      )
      if (showingIndex === -1 || props.items.length === showingIndex + 1) {
        showing.value = firstItemId
        return
      }

      showing.value = props.items[showingIndex + 1].id
    }, CAROUSEL_TIMEOUT) */
};
</script>

<template>
  <aside :class="classes.carousel">
    <figure
      v-for="item in props.items"
      :key="item.figure"
      :class="[
        classes.figure,
        {
          [classes['figure-show']]: item.id === showing,
        },
      ]"
    >
      <img :src="item.figure" :class="classes.img" alt="" draggable="false" />

      <!-- <figcaption v-if="item.text" :class="classes.caption">
        <span>
          {{ item.text }}
        </span>
      </figcaption> -->
    </figure>
  </aside>
</template>

<style lang="scss" module="classes" src="./Carousel.scss" />
